// Matches PO create batch cap.
export const MAX_RECEIVE_LINES = 50;
export const MAX_RECEIVE_LINES_MESSAGE = `A maximum of ${MAX_RECEIVE_LINES} lines can be received at a time.`;
// WHY: the receive page names this number in its truncation banner, so raising it there would lie.
export const RECEIVED_LINE_LIMIT = 500;
export const RECEIVE_INPUT_CONSTRAINTS = {
    purchaseOrder: { label: 'Purchase order' },
    locationGroup: { label: 'Location group' },
    location: { label: 'Location' },
    lotNumber: { label: 'Lot number', maxLength: 256 },
    purchaseOrderItem: { label: 'Purchase order item' },
};
//# sourceMappingURL=constraints.js.map